import * as React from 'react';
import Tools from '../../../Misc/Tools';

import './core-breadcrumbs.css'
/*
EXAMPLE

<div style={{position: 'absolute', width: '1000px', height: '200px', top: '100px', left: '100px'}}>
				<CoreBreadcrumbs pages={[
					{
						userFriendlyTitle: 'Home',
						url: ''
					},
					{
						userFriendlyTitle: 'Scenario 1',
						url: 'scenario1-piv-badge'
					},
					{
						userFriendlyTitle: 'Intro',
						url: 'scenario1-piv-badge'
					}
				]}></CoreBreadcrumbs>
			</div>


*/

const CoreBreadcrumbs = (props: CoreBreadcrumbsConfig) => {
  return (
    <div className='core-breadcrumbs-container'>
      {props.pages.map((page: CoreBreadcrumbsPageConfig, indx: number) => {
        return (
          <div className='core-breadcrumbs-container-single-page' onClick={() => {
            Tools.updateWindow(page.url);
          }}>
            <span className='default-text'>{page.userFriendlyTitle}</span>
            
            {indx < props.pages.length - 1 ? (
              <div className='core-breadcrumbs-container-single-page-arrow-container'>
                <div className='core-breadcrumbs-container-single-page-arrow'></div>
                <div className='core-breadcrumbs-container-single-page-arrow'></div>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

export default CoreBreadcrumbs;

export class CoreBreadcrumbsConfig {
  pages: CoreBreadcrumbsPageConfig[];
}

export class CoreBreadcrumbsPageConfig {
  userFriendlyTitle: string;
  url: string;
}